import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

let waitingForStartCount = 0;
let waitingForStart;

function getStarted() {
    console.log("Getting started ...");// eslint-disable-line
    clearTimeout(waitingForStart);
    if (window.Graphologi && window.Graphologi.loading === false) {
        ReactDOM.render(<App />, document.getElementById('root'));
    }
    else {
        console.log("Still waiting for Graphologi ...");// eslint-disable-line
        waitingForStartCount++;
        if (waitingForStartCount < 100) {
            waitingForStart = setTimeout(getStarted, 100);
        }
        else {
            alert("Cannot start Graphologi application");
        }
    }
}

getStarted();